import { render, staticRenderFns } from "./SampleList.vue?vue&type=template&id=bfd0c5d2&scoped=true"
import script from "./SampleList.vue?vue&type=script&lang=js"
export * from "./SampleList.vue?vue&type=script&lang=js"
import style0 from "./SampleList.vue?vue&type=style&index=0&id=bfd0c5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd0c5d2",
  null
  
)

export default component.exports